/**
 * Extracts token from URL search parameters
 * @returns The token from URL or null if not found
 */
export const getTokenFromUrl = (token: string): string | null => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(token) || null;
};

/**
 * Removes token from URL without page reload
 */
export const removeTokenFromUrl = (token: string): void => {
  const url = new URL(window.location.href);
  url.searchParams.delete(token);
  window.history.replaceState({}, '', url.toString());
};
